import { useTranslation } from 'react-i18next';
import { ErrorPage } from '@/components/features/error';

/**
 * 404 Not Found page.
 *
 * Route: * (catch-all)
 */
export function NotFoundPage() {
  const { t } = useTranslation('errors');

  return (
    <ErrorPage
      title={t('page.notFound')}
      message={t('page.notFoundDescription')}
      code="404"
      showHomeLink
    />
  );
}
